import { Controller } from "@hotwired/stimulus";

// When a user clicks a favorite from the Home/Favorites panel, the destination
// page would normally activate whichever tab its URL belongs to (CRM, Settings,
// etc.). This controller pins the side nav to Home for the next render so the
// user stays in their Favorites view instead of jumping tabs.
export default class extends Controller {
  rememberHome() {
    sessionStorage.setItem("admin-nav-tab-override", "home");
  }
}
